import * as React from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import { inject, observer } from 'mobx-react'
import { Row } from 'react-bootstrap'
import Link from 'src/components/atoms/input/buttons/Link'
import Accordion from 'src/components/containers/Accordion'
import MoreInfo from 'src/components/atoms/input/buttons/MoreInfo'
import {
  Financing,
  FinancingProvision
} from 'src/components/molecules/configurator/Financing'
import CustomModal from 'src/components/containers/CustomModal'
import ListOfProducts from 'src/components/molecules/configurator/ListOfProducts'
import { HintText, SmallHintText } from 'src/components/atoms/configurator'
import {
  ConfiguratorBox,
  HighlightInBox,
  VerticalAlignWrapper
} from 'src/components/containers/configurator/ConfiguratorBox'
import { StoreProps } from 'src/stores'

const bestPriceGuaranteed = require('src/assets/configurator/bestpreis_v2.png')
const funeralHomeCertificate = require('src/assets/wizard/funeralHomeCertificate.png')

const NumberFormat = require('react-number-format')

interface State {
  openInfo: boolean
}

@inject('confStore')
@observer
export class ConfiguratorOverview extends React.Component<any, State> {
  constructor(props: StoreProps) {
    super(props)
    this.state = {
      openInfo: false
    }
  }

  handleSave = () => {
    const { confStore, history } = this.props
    confStore.finishOffer(() => {
      const offer = confStore.getOffer
      if (offer.contactDetails.phone) {
        if (offer.planningReason === 'PROVISION') {
          history.push(`/planung/vorsorge/bestaetigung/${offer.uuid}`)
        } else {
          history.push(`/planung/abschluss/${offer.uuid}`)
        }
      } else {
        confStore.setContactDetailsPopup(true)
      }
    })
  }

  additionalCostsModal = () => {
    const { openInfo } = this.state
    return (
      <CustomModal
        cancelX
        noBorder
        open={openInfo}
        onClose={() => this.setState({ openInfo: false })}
        title='Übersicht zu Gebühren und Kosten von Fremdleistungen'>
        <p>
          Die Gesamtkosten einer Bestattung setzen sich aus den Leistungen des
          Bestatters und einer Zahl an Fremdleistungen zusammen. Sämtliche
          Bestattungsleistungen werden in Ihrem Angebot von Benu transparent und
          übersichtlich aufgeschlüsselt. Bei den Fremdleistungen handelt es sich
          um Kosten wie z.B. Friedhofs-, Krankenhaus-, Steinmetz- oder
          Behördengebühren. Diese können je nach Situation und Ort stark
          variieren.
          <br />
          <br />
          Benu legt Kosten für diverse Fremdleistungen für Sie aus und
          verrechnet diese in tatsächlicher Höhe an Sie weiter.
          <br />
          <br />
          Folgende Tabelle gibt einen groben Überblick zu Kosten und üblichen
          Fremdleistungen (Preise in Euro inkl. USt.):
        </p>

        <table className='price-table' style={{ width: '100%' }}>
          <tbody>
            <tr>
              <th>Art der Gebühr bzw. Fremdleistung</th>
              <th>Kostenschätzung</th>
            </tr>
            <tr>
              <td>
                <p>Totenbeschau durch den Amtsarzt</p>
              </td>
              <td>
                <p>&euro; 0 - 100</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Krankenhaus- od. Pflegeheimgebühren</p>
              </td>
              <td>
                <p>&euro; 100 - 200</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Kühlung der verstorbenen Person (z.B. im Krankenhaus)</p>
              </td>
              <td>
                <p>&euro; 50 - 200</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Ausstellungsgebühr für die Sterbeurkunde</p>
              </td>
              <td>
                <p>&euro; 10 - 20</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Bereitstellung der Grabstelle (einmalig)</p>
              </td>
              <td>
                <p>&euro; 190 - 490</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Beisetzungsgebühren am Friedhof</p>
              </td>
              <td>
                <p>&euro; 150 - 600</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Grabnutzungsgebühren (10 Jahre)</p>
              </td>
              <td>
                <p>&euro; 500 - 1.200</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Nutzungsgebühren für die Trauerhalle</p>
              </td>
              <td>
                <p>&euro; 200 - 500</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Steinmetzgebühren und Grabsteinkosten</p>
              </td>
              <td>
                <p>&euro; 500 - 6.000</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Totenmahl (für 20 Personen)</p>
              </td>
              <td>
                <p>&euro; 400 - 1.200</p>
              </td>
            </tr>
          </tbody>
        </table>
        <p>
          <br />
          <br />
          Bei der genauen Abschätzung der Kosten und bei der Einholung von
          Kostenvoranschlägen sind wir Ihnen gerne behilflich!
        </p>
      </CustomModal>
    )
  }

  renderButtons = () => {
    const { confStore } = this.props
    const offer = confStore.getOffer
    if (offer.orderConfirmed)
      return (
        <HighlightInBox
          style={{
            background: 'transparent',
            border: '5px solid #8dd691'
          }}>
          <p>
            <i className='fas fa-check' />{' '}
            <strong>Bestattung erfolgreich beauftragt</strong>
          </p>
          <p>
            Bei Änderungswünschen zur beauftragten Bestattung wenden Sie sich
            gerne jederzeit per E-Mail an{' '}
            <a href='mailto: kontakt@benu.at'>kontakt@benu.at</a> oder
            telefonisch unter <a href='tel:+4319076885'>01 907 68 85</a> an uns.
          </p>
        </HighlightInBox>
      )
    return (
      <>
        <Link onClick={this.handleSave}>Speichern & herunterladen</Link>
        <HintText>
          <i>Kostenlos und unverbindlich</i>
        </HintText>

        <VerticalAlignWrapper margin={15} horizontalAlignment='center'>
          <img
            src={
              offer.planningReason === 'PROVISION'
                ? funeralHomeCertificate
                : bestPriceGuaranteed
            }
            width='120'
            alt='Staatlich geprüfter Bestatter'
          />
        </VerticalAlignWrapper>
      </>
    )
  }

  renderDiscounts = () => {
    const { confStore } = this.props
    const discounts = confStore.getDiscounts()
    return (
      <>
        {discounts.map((d, index) => {
          const first = index === 0
          const discountValue = d.prices[0].amount / 100
          return (
            <SubTotalAmount
              condense='true'
              discount='true'
              first={first}
              bold='true'
              key={`discount-${index}`}>
              <p>{d.name}</p>
              <p>
                <NumberFormat
                  value={discountValue}
                  displayType='text'
                  thousandSeparator='.'
                  decimalSeparator=','
                  prefix=' € '
                  decimalScale={2}
                  fixedDecimalScale={!Number.isInteger(discountValue)}
                />
              </p>
            </SubTotalAmount>
          )
        })}
      </>
    )
  }

  render() {
    const { confStore } = this.props

    const offer = confStore.getOffer

    const productTotalNoDiscount = confStore.offerProductTotalWithDiscounts()
    const feesTotal = confStore.offerFeesTotal()
    const grandTotal = confStore.offerGrandTotal()

    let financingInfo = null
    if (
      offer.planningReason === 'PROVISION' &&
      offer.provision.includeTrustAccountCosts
    )
      financingInfo = <FinancingProvision />
    else if (offer.planningReason !== 'PROVISION' && !offer.orderConfirmed)
      financingInfo = <Financing />
    return (
      <ConfiguratorBox title='Kostenüberblick' footerComponent={financingInfo}>
        {this.additionalCostsModal()}

        <div
          id='ueberblick'
          style={{ position: 'relative', visibility: 'hidden', top: '-100px' }}
        />
        <ListOfProducts
          productsList={confStore.getSortedOfferProducts()}
          editable
        />

        {this.renderDiscounts()}

        <SubTotalAmount
          condense='true'
          bold='true'
          value={productTotalNoDiscount}
          name='total-no-discount'
          style={{
            textTransform: 'uppercase',
            paddingBottom: '15px',
            borderBottomWidth: '5px',
            borderBottomStyle: 'double',
            borderBottomColor: '#677D7F'
          }}>
          <p>Bestattungskosten</p>
          <p>
            <NumberFormat
              value={productTotalNoDiscount}
              displayType='text'
              thousandSeparator='.'
              decimalSeparator=','
              prefix='€ '
              decimalScale={2}
              fixedDecimalScale={!Number.isInteger(productTotalNoDiscount)}
            />
          </p>
        </SubTotalAmount>
        <SubTotalAmount
          condense='true'
          italic='true'
          value={feesTotal}
          name='fees-total'
          style={{
            paddingTop: '15px'
          }}>
          <p>+ Gebührenschätzung *</p>
          <p>
            <NumberFormat
              value={feesTotal}
              displayType='text'
              thousandSeparator='.'
              decimalSeparator=','
              prefix='€ '
              decimalScale={2}
              fixedDecimalScale={!Number.isInteger(feesTotal)}
            />
          </p>
        </SubTotalAmount>
        {offer.planningReason === 'PROVISION' &&
          offer.provision.includeTrustAccountCosts && (
            <SubTotalAmount
              value={99}
              name='maintenance-cost'
              condense='true'
              italic='true'>
              <p>+ Einrichtung Treuhandkonto</p>
              <p>
                <NumberFormat
                  value={99}
                  displayType='text'
                  thousandSeparator='.'
                  decimalSeparator=','
                  prefix='€ '
                />
              </p>
            </SubTotalAmount>
          )}
        <SubTotalAmount
          name='total-amount'
          value={grandTotal}
          condense='true'
          italic='true'
          style={{
            paddingBottom: '25px'
          }}>
          <p>Erwartete Gesamtkosten *</p>
          <p>
            <NumberFormat
              value={grandTotal}
              displayType='text'
              thousandSeparator='.'
              decimalSeparator=','
              prefix='€ '
              decimalScale={2}
              fixedDecimalScale={!Number.isInteger(grandTotal)}
            />
          </p>
        </SubTotalAmount>
        <SmallHintText>
          Alle Preise verstehen sich inkl. der jeweils geltenden Umsatzsteuer.
          Externe Gebühren (Verwaltungsgebühren, Totenbeschaugebühren,
          Krankenhausgebühren, Friedhofsgebühren, etc.) sind vom Angebot{' '}
          <u>nicht</u> umfasst.
          <br />
          <br />
        </SmallHintText>
        <Accordion title='Gebührenschätzung *' defaultCollapsed>
          <ListOfProducts
            productsList={confStore.getExternalFeeSorted()}
            isExternalFee={true}
          />
          <TotalAmount condense='true'>
            <p>Gesamt:</p>
            <p>
              <NumberFormat
                value={feesTotal}
                displayType='text'
                thousandSeparator='.'
                decimalSeparator=','
                prefix='€ '
                decimalScale={2}
                fixedDecimalScale={!Number.isInteger(feesTotal)}
              />
            </p>
          </TotalAmount>
          <SmallHintText>
            * Dies ist eine unverbindliche Einschätzung der externen Kosten und
            Gebühren
          </SmallHintText>
          <VerticalAlignWrapper
            margin={15}
            horizontalAlignment='center'
            color='#9abbbf'
            clickable
            onClick={() => this.setState({ openInfo: true })}>
            <InlineInfoIcon />
            Überblick zu externen Gebühren
          </VerticalAlignWrapper>
        </Accordion>
        {this.renderButtons()}
      </ConfiguratorBox>
    )
  }
}

const InlineInfoIcon = styled(MoreInfo)`
  position: unset;
  margin: 7.5px;
`

const TotalAmount = styled(Row)`
  ${(props) =>
    props.condense
      ? 'margin: 10px 0px; padding: 10px 0px;'
      : 'margin: 15px 0; padding: 7.5px 0px 15px;'}
  p {
    font-size: 16px;
    display: inline;
    margin: 0;
    font-weight: bold;
    float: left;
    color: #4a4a4a;
  }
  p:first-child {
    float: left;
  }
  p:last-child {
    float: right;
  }
`

const SubTotalAmount = styled(Row)`
  ${(props) =>
    props.condense
      ? 'margin: 0px 0px; padding: 6px 0px;'
      : 'margin: 25px 0; padding: 25px 0;'}
    ${(props) =>
      props.first
        ? 'padding: 15px 0px 6px; border-top: 1.5px solid #677D7F;'
        : 'border-top: 0px'}
  p {
    font-size: 16px;
    display: inline;
    margin: 0;
    float: left;
    ${(props) =>
      props.discount ? 'color: #75b488; font-weight: bold;' : 'color: #4a4a4a;'}
    ${(props) => (props.bold ? 'font-weight: bold;' : 'font-weight: regular;')}
        ${(props) =>
          props.italic ? 'font-style: italic;' : 'font-style: regular;'}
  }
  p:first-child {
    float: left;
  }
  p:last-child {
    float: right;
  }
`

export default withRouter(ConfiguratorOverview)



// WEBPACK FOOTER //
// ./src/components/organisms/configurator/ConfiguratorOverview.tsx